import produce from 'immer';
import gql from 'graphql-tag';
import { updateRangeQueryString } from './updateQueryString';
import qs from 'qs';
////////////////////////////////////////////////////////////////////////////////
// Queries
////////////////////////////////////////////////////////////////////////////////
export const isRangeFilterActive = parent => {
    return (searchParams) => {
        var _a;
        const query = __IN_SERVER__ ? searchParams : document.location.search;
        // If the search params includes the boolean filter id, the boolean filter
        // must be active
        return (_a = query) === null || _a === void 0 ? void 0 : _a.includes(parent.id);
    };
};
////////////////////////////////////////////////////////////////////////////////
export const rangeFilterValue = parent => {
    return (searchParams) => {
        var _a;
        const query = __IN_SERVER__ ? searchParams : document.location.search;
        if ((_a = query) === null || _a === void 0 ? void 0 : _a.includes(parent.id)) {
            const parsed = qs.parse(query, { ignoreQueryPrefix: true }).range;
            const vals = parsed[parent.id];
            return vals;
        }
        return null;
    };
};
const rangeClientFields = gql `
  fragment RangeClientFields on NumericRangeFilter {
    id
    value @client
    isActive @client
    min
    max
  }
`;
////////////////////////////////////////////////////////////////////////////////
// Mutations
////////////////////////////////////////////////////////////////////////////////
export const setRangeFilter = (_, { value, id }, { cache, getCacheKey }) => {
    const fragmentId = getCacheKey({
        id,
        __typename: 'NumericRangeFilter'
    });
    const rangeFilter = cache.readFragment({
        fragment: rangeClientFields,
        id: fragmentId
    });
    const [min, max] = value;
    const data = produce(rangeFilter, draft => {
        // The filter is active if the values passed in aren't the default values
        draft.isActive = min !== draft.min || max !== draft.max;
        draft.value = value;
    });
    cache.writeData({
        id: fragmentId,
        data
    });
    // Update the active filters in cache
    const activeFilters = updateActiveFilters(cache, data);
    updateRangeQueryString(activeFilters);
    return data;
};
////////////////////////////////////////////////////////////////////////////////
export const clearRangeFilter = (_, { id }, { cache, getCacheKey }) => {
    const fragmentId = getCacheKey({ id, __typename: 'NumericRangeFilter' });
    const rangeFilter = cache.readFragment({
        id: fragmentId,
        fragment: rangeClientFields
    });
    const data = produce(rangeFilter, draft => {
        draft.value = [draft.min, draft.max];
        draft.isActive = false;
    });
    cache.writeData({ id: fragmentId, data });
    const activeFilters = clearActiveFilter(cache, id);
    window.location.search && updateRangeQueryString(activeFilters);
    return data;
};
////////////////////////////////////////////////////////////////////////////////
function updateActiveFilters(cache, data) {
    const activeRangeFilterQuery = gql `
    query GetActiveRangeFilters {
      activeFilters @client {
        rangeFilters {
          id
          min
          max
        }
      }
    }
  `;
    const currentActiveFilters = cache.readQuery({ query: activeRangeFilterQuery });
    const { activeFilters } = produce(currentActiveFilters, draft => {
        const [min, max] = data.value;
        const existingRangeFilter = draft.activeFilters.rangeFilters.find(filter => filter.id === data.id);
        if (existingRangeFilter) {
            existingRangeFilter.min = min;
            existingRangeFilter.max = max;
        }
        else {
            draft.activeFilters.rangeFilters.push({
                id: data.id,
                min,
                max,
                __typename: 'RangeFilterInput'
            });
        }
    });
    cache.writeData({ data: { activeFilters } });
    return activeFilters;
}
////////////////////////////////////////////////////////////////////////////////
function clearActiveFilter(cache, id) {
    const activeRangeFilterQuery = gql `
    query GetActiveListFilters {
      activeFilters @client {
        rangeFilters {
          id
        }
      }
    }
  `;
    const { activeFilters } = cache.readQuery({
        query: activeRangeFilterQuery
    });
    const data = produce(activeFilters, draft => {
        draft.rangeFilters = draft.rangeFilters.filter(rangeFilter => rangeFilter.id !== id);
    });
    cache.writeData({
        data: { activeFilters: data }
    });
    return data;
}
//# sourceMappingURL=rangeFilter.js.map